import $ from 'jquery';

window.addEventListener('load', () => {
  // eslint-disable-next-line new-cap
  const sp = new StatusPage.page({ page: 'wykzh58rpbks' });

  sp.summary({
    success(data) {
      // adds the text description to the dropdown
      $('.statuspage-description').text(data.status.description);
      // appends the status indicator as a class name so we can use the right
      // color for the status light thing
      $('.statuspage-button').addClass(data.status.indicator);
    },
  });

  const chatLinks = document.querySelectorAll('.chat-link');

  for (let i = 0; i < chatLinks.length; i += 1) {
    chatLinks[i].addEventListener('click', () => {
      if (window.Intercom) {
        window.Intercom('show');
      } else {
        window.open('mailto:support@logrocket.com', '_blank');
      }
    });
  }
}, false);
